import { wxpgpConfigG } from './third'
import { getParams, addParams } from '@dt/fe-utils'
import { PayApi } from 'api'

/** 处理地理位置 */
export default class WxPayGoldPlanController {
  static init () {
    document.querySelector('#ddloading')?.remove()
    wxpgpConfigG.init(() => {
      wxpgpConfigG.showPage()
    })
  }

  static isOpen () {
    const { sub_mch_id, out_trade_no, check_code } = getParams()
    return sub_mch_id && out_trade_no && check_code
  }

  static goPath (path: string, orderInfo: any, extPara?: any) {
    const { codeType: ct, brandId: b, storeId: s, tableCode: t } = orderInfo
    let params = { ct, b, s } as any
    if (ct === 'table' && t) params.t = t
    if (extPara) params = { ...params, ...extPara }
    let url = addParams({
      url: path,
      params
    })
    wxpgpConfigG.jumpOut(url)
  }

  static async getOrderInfo () {
    const { sub_mch_id, out_trade_no, check_code } = getParams()
    const res = await PayApi.queryOrdersByPrepayId({
      subMchId: sub_mch_id,
      outTradeNo: out_trade_no,
      checkCode: check_code
    }) as any
    return res?.result
  }
}
